import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-translate';
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Form,
    Checkbox,
    Modal,
} from 'semantic-ui-react';

import Exit from '../../../assets/svg/Exit.svg';
import renommer from '../../../assets/svg/renommer.svg';

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app
})

class ConnectedUpdateListArticle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fkuidarticle: this.props.fkuidarticle,
            importImg: null,
            title: this.props.articleName,
            price: null,
            quantity: null,
            state: null,
            fkuidlist: this.props.fkuidlist,
            modalOpen: false,
        }
        this.handleChangeImportImg = this.handleChangeImportImg.bind(this);
        this.handleChangeTitle = this.handleChangeTitle.bind(this);
        this.handleSubmitUpdateListArticle = this.handleSubmitUpdateListArticle.bind(this);
    }


    handleSubmitUpdateListArticle(event) {
        event.preventDefault();
        var self = this;
        var form = new FormData();
        if (this.state.title !== undefined && this.state.title !== null) {
            form.append("title", this.state.title);
        }
        if (this.state.importImg !== undefined && this.state.importImg !== null) {
            form.append("importImg", this.state.importImg);
        }
        form.append("fkuidlist", this.state.fkuidlist);
        form.append("id", this.state.fkuidarticle);
        API.updateArticleList(this.props.app.token, form).then((res) => {
            var responseUpdate = res.data;
            self.setState({
                responseUpdate: responseUpdate
            })
            self.handleClose();
            self.props.changePrice();
        });
    }

    handleChangeTitle(event) {
        event.preventDefault();
        this.setState({
            title: event.target.value
        });
    }

    handleChangeImportImg(event) {
        this.setState({
            importImg: event.target.value
        });
    }


    handleOpen = () => this.setState({
        modalOpen: true,
    })

    handleClose = () => this.setState({
        modalOpen: false,

    })

    render() {
        const { t } = this.props
        return (
            <div>
                <Modal open={this.state.modalOpen}
                    onClose={this.handleClose} size='tiny' trigger={
                        <Image onClick={this.handleOpen} src={renommer} />
                    } >
                    <Modal.Header style={{ backgroundColor: '#eeeced', maxHeight: '70px' }}>
                        <Image onClick={this.handleClose} src={Exit} floated='right' />
                        <Grid>
                            <Grid.Row>
                                <Grid.Column textAlign='center'>
                                    <Header as='h3' style={{ color: '#0964c1', margin: '0em 0 1em 1.9em', paddingLeft: '30px', fontSize: '1em' }} textAlign='center'>{t("title2")}</Header>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Header>
                    <Modal.Content>
                        <Grid
                            textAlign='center'
                            style={{ height: '100%' }}
                            verticalAlign='middle'>
                           {/* <Grid.Row >
                                <Item.Header>{t("title1")}</Item.Header>
                            </Grid.Row>
                            <Grid.Row>
                                <p>{t("title3")}</p>
                                <Image />
                                <input name="myFile" onChange={this.handleChangeImportImg} type="file" />
                            </Grid.Row>*/}

                            <Grid.Row>
                            <Header as='h5' textAlign='left' style={{ marginLeft: '30px', color: '#717171' }}>{t("title3")}</Header>
                            <Container style={{ borderStyle: 'dashed', borderColor: '#c2c2c2', borderRadius: '5px', width: '450px' }}>
                                <Icon size='large' name='upload' style={{ margin: '1em 0 0 10em' }} />
                                <Header as='h5' textAlign='center' style={{ color: '#5e5e5e' }}>{t("title5")}</Header>
                                <Divider style={{ fontSize: '9px', color: '#b0b0b0' }} horizontal><i>{t("title6")}</i></Divider>

                                <label for="file" class="ui icon button" style={{ backgroundColor: '#0964c1', color: 'white', margin: '0 0 1em 11em ' }}>

                                    {t("title7")}</label>
                                <input type="file" id="file" style={{ display: 'none' }} />

                            </Container>
                        </Grid.Row>

                            <Grid.Row columns={2}>
                                <Grid.Column width={6}>
                                    <Item.Header fluid>{t("title4")}</Item.Header>
                                </Grid.Column>
                                <Grid.Column width={10}>
                                    <Input fluid name='title' style={{ backgroundColor: '#f7f7f9', borderRadius: '5px', border: '1px solid #c6c7c9' }} type='text' value={this.state.title} onChange={this.handleChangeTitle} />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row columns={2}>
                                <Grid.Column width={8}>
                                    <Button size='large' onClick={this.handleClose} fluid inverted style={{ backgroundColor: '#9c9c9c' }}>{t("title10")}</Button>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <form onSubmit={this.handleSubmitUpdateListArticle} >
                                        <Button size='large' fluid style={{ backgroundColor: '#0964c1', color: 'white' }}>{t("title11")}</Button>
                                    </form>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                </Modal>
            </div>
        )
    }
}
const UpdateListArticle = connect(mapStateToProps)(ConnectedUpdateListArticle);
export default translate("UpdateListArticle")(UpdateListArticle);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/UpdateListArticle.js